<template>
  <div>
    
    <a  href="#">
      <span style="color:white;" v-on:click="setLanguage('gb')" v-if="currentLanguage()=='FR'"><b><u> {{DifcurrentLanguage()}} </u></b></span>
      <span style="color:white;" v-on:click="setLanguage('fr')" v-if="currentLanguage()=='EN'"><b><u> {{DifcurrentLanguage()}} </u></b></span>
    </a>

    
  </div>
</template>


<script>
import Vue from "vue";

export default {
  name: "language-dropdown",

  props: {
    options: {
      type: Array,
      default: () => [
        {
          code: "gb",
          name: "english"
        },
        {
          code: "fr",
          name: "French"
        }
      ]
    }
  },
  methods: {
    setLanguage(locale) {
      //  console.log("LNGSET"+locale)
      Vue.i18n.set(locale);
    },

    currentLanguage() {
    
      if (Vue.i18n.locale() === "en" || Vue.i18n.locale() === "gb") {
        // console.log("LNG EN")
        return "EN";
      } else if (Vue.i18n.locale() === "fr") {
        return "FR";
         //console.log("LNG FR")
      }
    },
    DifcurrentLanguage() {
      if (Vue.i18n.locale() === "en" || Vue.i18n.locale() === "gb") {
        return "FR";
      } else if (Vue.i18n.locale() === "fr") {
        return "EN";
      }
    },

    flagIconClass(code) {
      return `flag-icon-${code}`;
    }
  }
};
</script>

<style lang="scss">
/*.language-dropdown {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
  height: 100%;
  padding: 0;

  .language-dropdown-button {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .flag-icon-large {
    width: 31px;
    height: 23px;
  }

  .flag-icon-small {
    min-width: 22px;
    height: 17px;
  }

  .dropdown-toggle {
    padding: 0;

    &:after {
      display: none;
    }
  }

  &.show {
    &:after {
      position: absolute;
      right: calc(50% - 10px);
      bottom: -2rem;
      display: block;
      width: 0;
      height: 0;
      content: "";
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-bottom: 10px solid #333;
      z-index: 2;
    }

    .dropdown-menu {
      left: auto;
      margin-top: 2rem;

      &.last {
        right: 0;
      }

      @include media-breakpoint-up(lg) {
        right: auto;
        left: 12px;
        margin-top: 12px;
      }
    }
  }

  .dropdown-menu {
    min-width: 8rem;
    max-width: 11rem;
    margin-top: 1.125rem;
    padding: 0;
    background-color: $dropdown-background;
    box-shadow: $dropdown-box-shadow;

    .dropdown-item {
      display: flex;
      align-items: center;
      height: 38px;
      padding: 9px 12px;

      .dropdown-item__text {
        padding-left: 12px;
        font-size: $font-size-base;
        line-height: 1.25;
      }

      &.active {
        color: $vue-green;
        background-color: $darkest-gray;
      }

      &:hover {
        background-color: $almost-black;
      }

      &:last-child {
        padding-top: 8px;
        padding-bottom: 10px;
      }
    }

    @include media-breakpoint-up(lg) {
      top: 42px;
    }
  }
}*/
</style>



// WEBPACK FOOTER //
// src/components/dropdowns/LanguageDropdown.vue